(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-results')) {
    customElements.define('before-after-results', class BeforeAfterResults extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = [...this.track.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { ticking = false; this.sync(); });
        }, { passive: true });

        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        });

        // Theme editor: jump to the slide being edited
        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((sl) => sl.dataset.blockId === e.detail.blockId);
          if (i > -1) { this.stop(); this.go(i, false); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setupAutoplay();
        this.setActive();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.stop();
      }

      go(i, smooth = true) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: smooth && !this.reduceMotion ? 'smooth' : 'auto'
        });
        this.setActive();
      }

      sync() {
        const w = this.track.clientWidth || 1;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index) { this.index = i; this.setActive(); }
      }

      setActive() {
        this.dots.forEach((dot, i) => {
          const on = i === this.index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
      }

      setupAutoplay() {
        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.dataset.autoplay !== 'true' || this.reduceMotion || inEditor || this.slides.length < 2) return;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        const pause = () => this.stop();
        const resume = () => this.start();
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('pointerdown', pause);
        this.start();
      }

      start() {
        if (!this.speed) return;
        this.stop();
        this.timer = setInterval(() => {
          if (!document.hidden) this.go(this.index + 1);
        }, this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('pk-header')) {
    customElements.define('pk-header', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.pkh1__drawer');
        this.openBtn = this.querySelector('[data-pkh1-open]');
        this.openBtn && this.openBtn.addEventListener('click', () => this.toggle(true));
        this.querySelectorAll('[data-pkh1-close]').forEach((el) => el.addEventListener('click', () => this.toggle(false)));
        this.onKey = (e) => { if (e.key === 'Escape') this.toggle(false); };
        this.onCart = (e) => {
          const r = e.detail && e.detail.resource;
          if (r && typeof r.item_count === 'number') return this.setCount(r.item_count);
          fetch(this.dataset.cartUrl + '.js').then((x) => x.json()).then((c) => this.setCount(c.item_count)).catch(() => {});
        };
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('cart:update', this.onCart);
      }
      disconnectedCallback() { document.removeEventListener('keydown', this.onKey); document.removeEventListener('cart:update', this.onCart); }
      toggle(open) {
        if (!this.drawer) return;
        this.drawer.classList.toggle('is-open', open);
        this.drawer.setAttribute('aria-hidden', String(!open));
        this.openBtn.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      setCount(n) {
        const c = this.querySelector('[data-cart-count]');
        if (c) { c.textContent = n; c.hidden = n === 0; }
        const l = this.querySelector('[data-pkh1-cart]'); if (l) l.setAttribute('aria-label', 'Cart, ' + n + ' items');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pookee-hero')) {
    class PookeeHero extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.ribbons = [];
        this.last = 0;
        this.tick = this.tick.bind(this);
        this.onResize = () => { clearTimeout(this.rt); this.rt = setTimeout(() => this.setup(), 200); };
        // Pause the ribbon while the page is scrolling, so the browser has time to draw the page (no white gaps)
        this.onScroll = () => {
          this.scrolling = true;
          clearTimeout(this.st);
          this.st = setTimeout(() => { this.scrolling = false; }, 180);
        };
        this.visible = true;
        this.start = () => { if (!this.reduce && !this.raf && this.visible && this.ribbons.length) { this.last = 0; this.raf = requestAnimationFrame(this.tick); } };
        (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(() => { this.setup(); this.start(); });
        window.addEventListener('resize', this.onResize);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        // Also stop it completely while the banner is off screen
        this.io = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; if (this.visible) this.start(); });
        this.io.observe(this);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.raf); this.raf = 0;
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        if (this.io) this.io.disconnect();
      }
      setup() {
        this.ribbons = [];
        this.querySelectorAll('[data-pkr-ribbon]').forEach((svg) => {
          if (svg.getBoundingClientRect().width === 0) return;
          const path = svg.querySelector('path');
          const tp = svg.querySelector('[data-pkr-tp]');
          const measure = svg.querySelector('[data-pkr-measure]');
          if (!tp.dataset.base) tp.dataset.base = tp.textContent.trim();
          const unitText = tp.dataset.base + '   \u2726   ';
          measure.textContent = unitText;
          const unit = measure.getComputedTextLength() || 300;
          const reps = Math.ceil((path.getTotalLength() + unit) / unit) + 1;
          tp.textContent = unitText.repeat(reps);
          this.ribbons.push({ tp, unit, offset: 0, speed: parseFloat(svg.dataset.speed) || 0 });
        });
      }
      tick(t) {
        if (!this.visible) { this.raf = 0; return; }
        const dt = this.last ? Math.min(0.05, (t - this.last) / 1000) : 0;
        this.last = t;
        if (this.scrolling) { this.raf = requestAnimationFrame(this.tick); return; }
        this.ribbons.forEach((r) => {
          r.offset -= r.speed * dt;
          if (r.offset <= -r.unit) r.offset += r.unit;
          r.tp.setAttribute('startOffset', r.offset.toFixed(2));
        });
        this.raf = requestAnimationFrame(this.tick);
      }
    }
    customElements.define('pookee-hero', PookeeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('pk-cart-page')) {
    customElements.define('pk-cart-page', class extends HTMLElement {
      connectedCallback() {
        this.q = (sel) => this.querySelector(sel);
        this.items = this.q('[data-pkcart-items]');
        this.offerEl = this.q('[data-pkcart-offer]');
        this.recoEl = this.q('[data-pkcart-reco]');
        this.recoTrack = this.q('[data-pkcart-reco-track]');
        this.grid = this.q('[data-pkcart-grid]');
        this.empty = this.q('[data-pkcart-empty]');
        this.bar = this.q('[data-pkcart-bar]');
        this.totalEl = this.q('[data-pkcart-total]');
        this.barTotal = this.q('[data-pkcart-bartotal]');
        this.offerNote = this.q('[data-pkcart-offernote]');
        this.star = this.q('[data-pkcart-star]');
        this.starNum = this.q('[data-pkcart-starnum]');
        this.cartUrl = this.dataset.cartUrl;
        this.currency = this.dataset.currency || 'INR';
        this.tiers = this.parseTiers(this.dataset.tiers || '');
        this.recoCache = {};
        this.bdOpen = true;
        try { this.mrp = JSON.parse(this.q('[data-pkcart-mrp]').textContent) || {}; } catch (err) { this.mrp = {}; }
        this.bdEl = this.q('[data-pkcart-bd]');
        this.bdEl.addEventListener('click', (e) => { if (e.target.closest('[data-pkcart-bdtoggle]')) { this.bdOpen = !this.bdOpen; if (this.cart) this.render(this.cart); } });
        this.items.addEventListener('click', (e) => this.onItems(e));
        this.recoTrack.addEventListener('click', (e) => { const b = e.target.closest('[data-pkcart-radd]'); if (b) this.addReco(b); });
        this.onUpdate = (e) => { if (e.detail && e.detail.fromPkcart) return; this.refresh(); };
        document.addEventListener('cart:update', this.onUpdate);
        try { const c0 = JSON.parse(this.q('[data-pkcart-json]').textContent); this.render(c0); this.withMrp(c0).then((c) => this.render(c)); } catch (err) { this.refresh(); }

        /* Shiprocket (Fastrr): when its checkout button is shown in a slot, hide our own button there (only one button ever) */
        this.syncSR = () => this.querySelectorAll('.pkcart__cta').forEach((cta) => {
          const sr = cta.querySelector('.shiprocket-headless');
          const on = !!sr && sr.children.length > 0 && getComputedStyle(sr).display !== 'none';
          cta.classList.toggle('has-sr', on);
        });
        this.srObs = new MutationObserver(() => this.syncSR());
        this.querySelectorAll('.pkcart__cta').forEach((cta) => this.srObs.observe(cta, { childList: true, subtree: true }));
        this.syncSR(); window.addEventListener('load', this.syncSR); setTimeout(this.syncSR, 1500); setTimeout(this.syncSR, 4000);
      }
      disconnectedCallback() { document.removeEventListener('cart:update', this.onUpdate); if (this.srObs) this.srObs.disconnect(); window.removeEventListener('load', this.syncSR); }

      money(cents) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2); }
      }
      esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      img(url, w) { if (!url) return ''; url = String(url).replace(/^\/\//, 'https://'); if (/^data:/.test(url)) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
      parseTiers(str) {
        return str.split(',').map((p) => p.split(':').map((x) => parseFloat(String(x).replace(/[^\d.]/g, ''))))
          .filter((t) => t.length === 2 && t[0] > 0 && t[1] > 0)
          .map((t) => ({ qty: Math.round(t[0]), price: Math.round(t[1] * 100) }))
          .sort((a, b) => a.qty - b.qty);
      }
      tierLabel(t) { return 'BUY ' + t.qty + ' @ ' + this.money(t.price); }
      fillMsg(tpl, vars) { return this.esc(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m)); }
      offerTotal(cart) {
        const units = [];
        cart.items.forEach((i) => { for (let q = 0; q < i.quantity; q++) units.push(i.final_price); });
        units.sort((a, b) => a - b);   /* cheapest first: the offer covers the cheapest items, the most expensive stay at full price */
        let best = null;
        this.tiers.forEach((t) => {
          if (units.length < t.qty) return;
          const total = t.price + units.slice(t.qty).reduce((a, b) => a + b, 0);
          if (total < cart.total_price && (!best || total < best.total)) best = { tier: t, total };
        });
        return best;
      }

      refresh() {
        return fetch(this.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => this.withMrp(c)).then((c) => this.render(c)).catch(() => {});
      }

      /* MRP (compare-at price) is not in cart.js: read it from /products/<handle>.js once per product */
      withMrp(cart) {
        const need = [...new Set(cart.items.filter((i) => !(String(i.variant_id) in this.mrp)).map((i) => i.handle))];
        if (!need.length) return Promise.resolve(cart);
        const root = (this.dataset.root || '/').replace(/\/$/, '');
        return Promise.all(need.map((h) => fetch(root + '/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json()).then((p) => (p.variants || []).forEach((v) => { this.mrp[String(v.id)] = v.compare_at_price || 0; })).catch(() => {})))
          .then(() => cart);
      }
      unitMrp(i) { return Math.max(this.mrp[String(i.variant_id)] || 0, i.original_price || 0, i.final_price || 0); }

      /* Subtotal (MRP) - discounts = Total */
      renderBreakdown(cart, best) {
        let mrpTotal = 0, origTotal = 0;
        cart.items.forEach((i) => { mrpTotal += this.unitMrp(i) * i.quantity; origTotal += i.original_line_price; });
        const lines = [];
        if (mrpTotal > origTotal) lines.push([this.dataset.mrpLabel || 'Discount on MRP', mrpTotal - origTotal]);
        const shop = {};
        cart.items.forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => {
          const k = (a.discount_application && a.discount_application.title) || 'Discount'; shop[k] = (shop[k] || 0) + (a.amount || 0); }));
        (cart.cart_level_discount_applications || []).forEach((a) => { const k = a.title || 'Discount'; shop[k] = (shop[k] || 0) + (a.total_allocated_amount || 0); });
        Object.keys(shop).forEach((k) => { if (shop[k] > 0) lines.push([k, shop[k]]); });
        if (best) lines.push([this.tierLabel(best.tier), cart.total_price - best.total]);
        const disc = lines.reduce((a, l) => a + l[1], 0);
        if (this.dataset.breakdown !== 'true' || !disc) { this.bdEl.hidden = true; return false; }
        const row = (label, val, cls) => '<div class="pkcart__bd-row' + (cls || '') + '"><span>' + label + '</span>' + val + '</div>';
        this.bdEl.innerHTML = row(this.esc(this.dataset.subLabel || 'Subtotal'), '<b>' + this.money(mrpTotal) + '</b>')
          + row('Discounts applied <button type="button" class="pkcart__bd-toggle" data-pkcart-bdtoggle aria-expanded="' + this.bdOpen + '">' + (this.bdOpen ? 'Hide details' : 'Show details') + '</button>', '<span class="pkcart__bd-minus">-' + this.money(disc) + '</span>', ' pkcart__bd-row--disc')
          + '<div class="pkcart__bd-details">' + lines.map((l) => row(this.esc(l[0]), '<span class="pkcart__bd-minus">-' + this.money(l[1]) + '</span>')).join('') + '</div>';
        this.bdEl.classList.toggle('is-collapsed', !this.bdOpen);
        this.bdEl.hidden = false;
        return true;
      }

      render(cart) {
        this.cart = cart;
        const n = cart.item_count;
        if (this.star) { this.star.hidden = !n; this.starNum.textContent = n; }
        this.grid.hidden = !n; this.empty.hidden = !!n; this.bar.hidden = !n;
        if (!n) { this.offerEl.hidden = true; return; }

        // offer box
        let got = null;
        if (this.dataset.offersOn === 'true' && this.tiers.length) {
          const next = this.tiers.find((t) => t.qty > n);
          got = this.tiers.filter((t) => t.qty <= n).pop() || null;
          const b = (t) => '<b>' + this.tierLabel(t) + '</b>';
          const msg = next ? (got ? this.fillMsg(this.dataset.msgUnlocked, { offer: b(got), n: next.qty - n, next: b(next) }) : this.fillMsg(this.dataset.msgNext, { n: next.qty - n, offer: b(next) }))
                           : this.fillMsg(this.dataset.msgMax, { offer: b(got) });
          const max = this.tiers[this.tiers.length - 1].qty;
          const marks = this.tiers.map((t) => '<span class="pkcart__mark' + (n >= t.qty ? ' is-on' : '') + '" style="left:' + (t.qty / max) * 100 + '%">' + t.qty + '<span>' + this.esc(this.money(t.price)) + '</span></span>').join('');
          this.offerEl.innerHTML = '<p class="pkcart__banner">' + this.esc('BUY ANY ' + this.tiers[0].qty + ' @ ' + this.money(this.tiers[0].price)) + '</p><p class="pkcart__omsg">' + msg + '</p>'
            + '<div class="pkcart__track" aria-hidden="true"><span class="pkcart__fill" style="width:' + Math.min(100, (n / max) * 100) + '%"></span>' + marks + '</div>';
          this.offerEl.hidden = false;
        } else { this.offerEl.hidden = true; }

        // total
        const best = this.dataset.showPrice === 'true' && this.dataset.offersOn === 'true' ? this.offerTotal(cart) : null;
        const hasBd = this.renderBreakdown(cart, best);
        const finalTotal = this.money(best ? best.total : cart.total_price);
        this.totalEl.innerHTML = best && !hasBd ? '<s>' + this.money(cart.total_price) + '</s>' + finalTotal : finalTotal;
        this.barTotal.innerHTML = best ? '<s>' + this.money(cart.total_price) + '</s>' + finalTotal : finalTotal;
        if (this.offerNote) this.offerNote.hidden = !best;

        // items
        const applied = got ? '<p class="pkcart__applied">✓ ' + this.fillMsg(this.dataset.applied, { offer: this.esc(this.tierLabel(got)) }) + '</p>' : '';
        this.items.innerHTML = '<p class="pkcart__card-title">Order summary</p>' + applied + '<ul class="pkcart__list">' + cart.items.map((i) => this.itemHtml(i)).join('') + '</ul>';
        this.loadReco(cart);
      }

      itemHtml(i) {
        const src = i.featured_image && i.featured_image.url ? this.img(i.featured_image.url, 200) : (i.image ? this.img(i.image, 200) : '');
        const variant = i.variant_title && i.variant_title !== 'Default Title' ? '<p class="pkcart__var">' + this.esc(i.variant_title) + '</p>' : '';
        const mrp = this.unitMrp(i);
        const compare = mrp > i.final_price ? mrp : 0;
        const was = compare ? '<s>' + this.money(compare * i.quantity) + '</s>' : '';
        const off = compare ? '<span class="pkcart__off">' + Math.round((1 - i.final_price / compare) * 100) + '% off</span>' : '';
        return '<li class="pkcart__item" data-key="' + this.esc(i.key) + '">'
          + '<a class="pkcart__img" href="' + this.esc(i.url) + '">' + (src ? '<img src="' + this.esc(src) + '" alt="' + this.esc(i.product_title) + '" loading="lazy">' : '') + '<span class="pkcart__qbadge">' + i.quantity + '</span></a>'
          + '<div><a class="pkcart__name" href="' + this.esc(i.url) + '">' + this.esc(i.product_title) + '</a>' + variant
          + '<p class="pkcart__prices"><span>' + this.money(i.final_line_price) + '</span>' + was + off + '</p>'
          + '<div class="pkcart__qty"><button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button><span>' + i.quantity + '</span><button type="button" data-act="inc" aria-label="Increase quantity">+</button></div></div>'
          + '<button type="button" class="pkcart__rm" data-act="rm" aria-label="Remove ' + this.esc(i.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button>'
          + '</li>';
      }

      onItems(e) {
        const b = e.target.closest('[data-act]'); if (!b) return;
        const li = b.closest('.pkcart__item');
        const item = this.cart && this.cart.items.find((x) => x.key === li.dataset.key); if (!item) return;
        const q = b.dataset.act === 'inc' ? item.quantity + 1 : b.dataset.act === 'dec' ? item.quantity - 1 : 0;
        li.classList.add('is-busy');
        fetch(this.cartUrl.replace(/\/$/, '') + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: Math.max(q, 0) }) })
          .then((r) => (r.ok ? r.json() : Promise.reject()))
          .then((cart) => this.withMrp(cart))
          .then((cart) => { this.render(cart); document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, fromPkcart: true, fromPkc: true } })); })
          .catch(() => this.refresh());
      }

      loadReco(cart) {
        if (this.dataset.recoOn !== 'true' || !cart.items.length) { this.recoEl.hidden = true; return; }
        const pid = cart.items[0].product_id;
        const inCart = new Set(cart.items.map((i) => i.product_id));
        const limit = parseInt(this.dataset.recoLimit, 10) || 4;
        const show = (products) => {
          const list = products.filter((p) => !inCart.has(p.id) && p.available).slice(0, limit);
          if (!list.length) { this.recoEl.hidden = true; return; }
          this.recoTrack.innerHTML = list.map((p) => {
            const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
            const img = p.featured_image ? this.img(p.featured_image, 160) : '';
            const was = p.compare_at_price > p.price ? '<s>' + this.money(p.compare_at_price) + '</s>' : '';
            const btn = (p.variants || []).length > 1 ? '<a class="pkcart__radd" href="' + this.esc(p.url) + '">Choose</a>'
                      : '<button type="button" class="pkcart__radd" data-pkcart-radd="' + (v ? v.id : '') + '">' + this.esc(this.dataset.recoBtn) + '</button>';
            return '<div class="pkcart__rcard">' + (img ? '<a href="' + this.esc(p.url) + '"><img src="' + this.esc(img) + '" alt="' + this.esc(p.title) + '" loading="lazy"></a>' : '<span></span>')
              + '<div><a class="pkcart__rname" href="' + this.esc(p.url) + '">' + this.esc(p.title) + '</a><div class="pkcart__rrow"><span class="pkcart__rprice">' + was + this.money(p.price) + '</span>' + btn + '</div></div></div>';
          }).join('');
          this.recoEl.hidden = false;
        };
        if (this.recoCache[pid]) { show(this.recoCache[pid]); return; }
        fetch((this.dataset.recoUrl || '/recommendations/products') + '.json?product_id=' + pid + '&limit=' + (limit + cart.items.length) + '&intent=related')
          .then((r) => r.json()).then((j) => { this.recoCache[pid] = j.products || []; show(this.recoCache[pid]); })
          .catch(() => { this.recoEl.hidden = true; });
      }

      addReco(btn) {
        if (btn.getAttribute('aria-busy') === 'true' || !btn.dataset.pkcartRadd) return;
        btn.setAttribute('aria-busy', 'true');
        // XMLHttpRequest on purpose: the cart drawer watches fetch(/cart/add) and would pop open over the cart page
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.dataset.root.replace(/\/$/, '') + '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json'); xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = () => { if (xhr.status >= 200 && xhr.status < 300) { this.refresh(); document.dispatchEvent(new CustomEvent('cart:update', { detail: { fromPkcart: true, fromPkc: true } })); } else btn.removeAttribute('aria-busy'); };
        xhr.onerror = () => btn.removeAttribute('aria-busy');
        xhr.send(JSON.stringify({ items: [{ id: Number(btn.dataset.pkcartRadd), quantity: 1 }] }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p-tabs-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.scroller = this.querySelector('.hp-tb__bar-scroll');
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => this.onKey(e, i));
        });

        // Theme editor: open the tab being edited
        this.onBlockSelect = (e) => {
          const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
          if (i > -1) this.select(i, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        const active = this.tabs.findIndex((t) => t.classList.contains('is-active'));
        this.keepInView(this.tabs[Math.max(active, 0)], false);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          this.panels[i].hidden = !on;
        });
        if (focus) this.tabs[index].focus();
        this.keepInView(this.tabs[index], true);
      }

      onKey(e, i) {
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }

      keepInView(tab, smooth) {
        if (!tab || !this.scroller || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
        const left = tab.offsetLeft - (this.scroller.clientWidth - tab.offsetWidth) / 2;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollTo({ left, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-404"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-404')) {
    customElements.define('pk-404', class extends HTMLElement {
      connectedCallback() {
        this.img = this.querySelector('img[data-src]');
        const start = () => {
          if (this.img && !this.img.getAttribute('src')) this.img.src = this.img.dataset.src;   /* image tabhi load hoti hai, isliye wink shuru se dikhta hai */
          this.classList.add('is-in');
        };
        if (!('IntersectionObserver' in window)) return start();
        this.io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { start(); this.io.disconnect(); } }, { threshold: 0.3 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-bestsellers')) {
    customElements.define('pk-bestsellers', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pkb-track]');
        this.prev = this.querySelector('[data-pkb-prev]');
        this.next = this.querySelector('[data-pkb-next]');
        this.wrap = this.querySelector('.pkb__carousel');
        const step = (dir) => {
          const item = this.track.querySelector('.pkb__item');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
          this.track.scrollBy({ left: dir * ((item ? item.offsetWidth : 300) + gap), behavior: 'smooth' });
        };
        this.prev && this.prev.addEventListener('click', () => step(-1));
        this.next && this.next.addEventListener('click', () => step(1));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.wrap.classList.toggle('no-scroll', max <= 2);
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        };
        this.track.addEventListener('scroll', () => { if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => { this.update(); this.ticking = false; }); } }, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.update); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-cart-drawer"]) return;
  try {
    
  /* AJAX add-to-cart detect: drawer khud khul jaata hai */
  if (!window.__pkcFetchPatched) {
    window.__pkcFetchPatched = true;
    const _fetch = window.fetch;
    window.fetch = function (...args) {
      const p = _fetch.apply(this, args);
      try {
        const u = String((args[0] && args[0].url) || args[0] || '');
        if (/\/cart\/add(\.js)?(\?|$)/.test(u)) {
          p.then((r) => { if (r.ok) document.dispatchEvent(new CustomEvent('cart:open')); }).catch(() => {});
        }
      } catch (e) {}
      return p;
    };
  }

  if (!customElements.get('pk-cart-drawer')) {
    customElements.define('pk-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.pkc__panel');
        this.content = this.querySelector('[data-pkc-content]');
        this.offerEl = this.querySelector('[data-pkc-offer]');
        this.recoEl = this.querySelector('[data-pkc-reco]');
        this.recoTrack = this.querySelector('[data-pkc-reco-track]');
        this.foot = this.querySelector('[data-pkc-foot]');
        this.note = this.querySelector('[data-pkc-note]');
        this.countEl = this.querySelector('[data-pkc-count]');
        this.subEl = this.querySelector('[data-pkc-subtotal]');
        this.offerNote = this.querySelector('[data-pkc-offernote]');
        this.emptyTpl = this.querySelector('template[data-pkc-empty]');
        this.cartUrl = this.dataset.cartUrl;
        this.currency = this.dataset.currency || 'INR';
        this.tiers = this.parseTiers(this.dataset.tiers || '');
        this.recoCache = {};
        this.cart = null;
        this.bdOpen = false;
        try { this.mrp = JSON.parse(this.querySelector('[data-pkc-mrp]').textContent) || {}; } catch (err) { this.mrp = {}; }
        this.bdEl = this.querySelector('[data-pkc-bd]');
        this.bdEl.addEventListener('click', (e) => { if (e.target.closest('[data-pkc-bdtoggle]')) { this.bdOpen = !this.bdOpen; if (this.cart) this.render(this.cart); } });

        this.querySelectorAll('[data-pkc-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.content.addEventListener('click', (e) => this.onBody(e));
        this.recoTrack.addEventListener('click', (e) => { const b = e.target.closest('[data-pkc-radd]'); if (b) this.addReco(b); });

        this.onDocClick = (e) => {
          /* header cart icon, or any link to the cart page (outside the drawer) opens the drawer — on every page */
          const cartPath = this.cartUrl.replace(/\/$/, '');
          const t = e.target.closest('[data-pkh1-cart], a[href]');
          if (!t || this.contains(t) || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
          if (!t.hasAttribute('data-pkh1-cart')) {
            let path = '';
            try { path = new URL(t.getAttribute('href'), location.href).pathname.replace(/\/$/, ''); } catch (err) { return; }
            if (path !== cartPath) return;
          }
          e.preventDefault();
          this.open();
        };
        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.onOpen = () => this.open();
        this.onUpdate = (e) => {
          if (e.detail && e.detail.fromPkc) return;
          if (this.classList.contains('is-open')) this.refresh();
        };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('cart:open', this.onOpen);
        document.addEventListener('cart:update', this.onUpdate);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('cart:open', this.onOpen);
        document.removeEventListener('cart:update', this.onUpdate);
      }

      open() {
        if (!this.classList.contains('is-open')) this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        this.panel.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        this.refresh();
        setTimeout(() => { const x = this.querySelector('.pkc__x'); x && x.focus(); }, 320);
      }
      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }

      money(cents) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2); }
      }
      esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      img(url, w) { if (!url) return ''; if (/^data:/.test(url)) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

      /* "3:599, 4:799" -> [{qty:3, price:59900}, {qty:4, price:79900}] */
      parseTiers(str) {
        return str.split(',').map((p) => p.split(':').map((x) => parseFloat(String(x).replace(/[^\d.]/g, ''))))
          .filter((t) => t.length === 2 && t[0] > 0 && t[1] > 0)
          .map((t) => ({ qty: Math.round(t[0]), price: Math.round(t[1] * 100) }))
          .sort((a, b) => a.qty - b.qty);
      }
      tierLabel(t) { return 'BUY ' + t.qty + ' @ ' + this.money(t.price); }
      fillMsg(tpl, vars) { return this.esc(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m)); }

      /* offer price: BUY N @ ₹X covers the N cheapest items, every other item keeps its own price */
      offerTotal(cart) {
        const units = [];
        cart.items.forEach((i) => { for (let q = 0; q < i.quantity; q++) units.push(i.final_price); });
        units.sort((a, b) => a - b);   /* cheapest first: the offer covers the cheapest items, the most expensive stay at full price */
        let best = null;
        this.tiers.forEach((t) => {
          if (units.length < t.qty) return;
          const total = t.price + units.slice(t.qty).reduce((a, b) => a + b, 0);
          if (total < cart.total_price && (!best || total < best.total)) best = { tier: t, total };
        });
        return best;
      }

      renderOffer(cart) {
        if (this.dataset.offersOn !== 'true' || !this.tiers.length || !cart.item_count) { this.offerEl.hidden = true; return; }
        const n = cart.item_count;
        const next = this.tiers.find((t) => t.qty > n);
        const got = this.tiers.filter((t) => t.qty <= n).pop();
        const b = (t) => '<b>' + this.tierLabel(t) + '</b>';
        let msg;
        if (next) msg = got ? this.fillMsg(this.dataset.msgUnlocked, { offer: b(got), n: next.qty - n, next: b(next) }) : this.fillMsg(this.dataset.msgNext, { n: next.qty - n, offer: b(next) });
        else msg = this.fillMsg(this.dataset.msgMax, { offer: b(got) });
        const banner = 'BUY ANY ' + this.tiers[0].qty + ' @ ' + this.money(this.tiers[0].price);
        const max = this.tiers[this.tiers.length - 1].qty;
        const marks = this.tiers.map((t) => '<span class="pkc__mark' + (n >= t.qty ? ' is-on' : '') + '" style="left:' + (t.qty / max) * 100 + '%">' + t.qty + '<span>' + this.esc(this.money(t.price)) + '</span></span>').join('');
        this.offerEl.innerHTML = '<p class="pkc__banner">' + this.esc(banner) + '</p><p class="pkc__omsg">' + msg + '</p>'
          + '<div class="pkc__track" aria-hidden="true"><span class="pkc__fill" style="width:' + Math.min(100, (n / max) * 100) + '%"></span>' + marks + '</div>';
        this.offerEl.hidden = false;
        this.gotTier = got;
      }

      refresh() {
        return fetch(this.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json()).then((c) => this.withMrp(c)).then((c) => this.render(c)).catch(() => {});
      }

      /* MRP (compare-at price) is not in cart.js: read it from /products/<handle>.js once per product */
      withMrp(cart) {
        const need = [...new Set(cart.items.filter((i) => !(String(i.variant_id) in this.mrp)).map((i) => i.handle))];
        if (!need.length) return Promise.resolve(cart);
        const root = (this.dataset.root || '/').replace(/\/$/, '');
        return Promise.all(need.map((h) => fetch(root + '/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json()).then((p) => (p.variants || []).forEach((v) => { this.mrp[String(v.id)] = v.compare_at_price || 0; })).catch(() => {})))
          .then(() => cart);
      }
      unitMrp(i) { return Math.max(this.mrp[String(i.variant_id)] || 0, i.original_price || 0, i.final_price || 0); }

      /* Subtotal (MRP) - discounts = Total */
      renderBreakdown(cart, best) {
        let mrpTotal = 0, origTotal = 0;
        cart.items.forEach((i) => { mrpTotal += this.unitMrp(i) * i.quantity; origTotal += i.original_line_price; });
        const lines = [];
        if (mrpTotal > origTotal) lines.push([this.dataset.mrpLabel || 'Discount on MRP', mrpTotal - origTotal]);
        const shop = {};
        cart.items.forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => {
          const k = (a.discount_application && a.discount_application.title) || 'Discount'; shop[k] = (shop[k] || 0) + (a.amount || 0); }));
        (cart.cart_level_discount_applications || []).forEach((a) => { const k = a.title || 'Discount'; shop[k] = (shop[k] || 0) + (a.total_allocated_amount || 0); });
        Object.keys(shop).forEach((k) => { if (shop[k] > 0) lines.push([k, shop[k]]); });
        if (best) lines.push([this.tierLabel(best.tier), cart.total_price - best.total]);
        const disc = lines.reduce((a, l) => a + l[1], 0);
        if (this.dataset.breakdown !== 'true' || !disc) { this.bdEl.hidden = true; return false; }
        const row = (label, val, cls) => '<div class="pkc__bd-row' + (cls || '') + '"><span>' + label + '</span>' + val + '</div>';
        this.bdEl.innerHTML = row(this.esc(this.dataset.subLabel || 'Subtotal'), '<b>' + this.money(mrpTotal) + '</b>')
          + row('Discounts applied <button type="button" class="pkc__bd-toggle" data-pkc-bdtoggle aria-expanded="' + this.bdOpen + '">' + (this.bdOpen ? 'Hide details' : 'Show details') + '</button>', '<span class="pkc__bd-minus">-' + this.money(disc) + '</span>', ' pkc__bd-row--disc')
          + '<div class="pkc__bd-details">' + lines.map((l) => row(this.esc(l[0]), '<span class="pkc__bd-minus">-' + this.money(l[1]) + '</span>')).join('') + '</div>';
        this.bdEl.classList.toggle('is-collapsed', !this.bdOpen);
        this.bdEl.hidden = false;
        return true;
      }

      render(cart) {
        this.cart = cart;
        const n = cart.item_count;
        this.countEl.textContent = n ? n + (n === 1 ? ' item' : ' items') : '';
        this.gotTier = null;
        this.renderOffer(cart);
        if (!n) {
          this.foot.hidden = true;
          if (this.note) this.note.hidden = true;
          this.recoEl.hidden = true;
          this.content.innerHTML = '';
          this.content.appendChild(this.emptyTpl.content.cloneNode(true));
          const box = this.content.querySelector('.pkc__empty');
          const img = box.querySelector('img');
          setTimeout(() => { img.src = img.dataset.src; box.classList.add('is-in'); }, this.classList.contains('is-open') ? 300 : 0);  /* drawer khulne ke baad mascot pop-up */
          return;
        }
        this.foot.hidden = false;
        if (this.note) this.note.hidden = false;
        const best = this.dataset.showPrice === 'true' && this.dataset.offersOn === 'true' ? this.offerTotal(cart) : null;
        const hasBd = this.renderBreakdown(cart, best);
        if (best && !hasBd) this.subEl.innerHTML = '<s>' + this.money(cart.total_price) + '</s>' + this.money(best.total);
        else this.subEl.textContent = this.money(best ? best.total : cart.total_price);
        if (this.offerNote) this.offerNote.hidden = !best;
        const applied = this.gotTier ? '<p class="pkc__applied">✓ ' + this.fillMsg(this.dataset.applied, { offer: this.esc(this.tierLabel(this.gotTier)) }) + '</p>' : '';
        this.content.innerHTML = '<div class="pkc__card"><p class="pkc__card-title"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>Order summary</p>'
          + applied + '<ul class="pkc__list">' + cart.items.map((i) => this.itemHtml(i)).join('') + '</ul></div>';
        this.loadReco(cart);
      }

      itemHtml(i) {
        const src = i.featured_image && i.featured_image.url ? this.img(i.featured_image.url, 160) : '';
        const variant = i.variant_title && i.variant_title !== 'Default Title' ? '<p class="pkc__var">' + this.esc(i.variant_title) + '</p>' : '';
        const mrp = this.unitMrp(i);
        const compare = mrp > i.final_price ? mrp : 0;
        const was = compare ? '<s>' + this.money(compare * i.quantity) + '</s>' : '';
        const off = compare ? '<span class="pkc__off">' + Math.round((1 - i.final_price / compare) * 100) + '% off</span>' : '';
        return '<li class="pkc__item" data-key="' + this.esc(i.key) + '">'
          + '<a class="pkc__img" href="' + this.esc(i.url) + '">' + (src ? '<img src="' + this.esc(src) + '" alt="' + this.esc(i.product_title) + '" loading="lazy">' : '') + '<span class="pkc__qbadge">' + i.quantity + '</span></a>'
          + '<div><a class="pkc__name" href="' + this.esc(i.url) + '">' + this.esc(i.product_title) + '</a>' + variant
          + '<div class="pkc__prices"><span>' + this.money(i.final_line_price) + '</span>' + was + off + '</div>'
          + '<div class="pkc__qty"><button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button><span>' + i.quantity + '</span><button type="button" data-act="inc" aria-label="Increase quantity">+</button></div></div>'
          + '<div class="pkc__side"><button type="button" class="pkc__rm" data-act="rm" aria-label="Remove ' + this.esc(i.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>'
          + '</li>';
      }

      /* "You may also like" — Shopify recommendations for the first item, without products already in the cart */
      loadReco(cart) {
        if (this.dataset.recoOn !== 'true' || !cart.items.length) { this.recoEl.hidden = true; return; }
        const pid = cart.items[0].product_id;
        const inCart = new Set(cart.items.map((i) => i.product_id));
        const limit = parseInt(this.dataset.recoLimit, 10) || 6;
        const show = (products) => {
          const list = products.filter((p) => !inCart.has(p.id) && p.available).slice(0, limit);
          if (!list.length) { this.recoEl.hidden = true; return; }
          this.recoTrack.innerHTML = list.map((p) => {
            const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
            const img = p.featured_image ? this.img(String(p.featured_image).replace(/^\/\//, 'https://'), 140) : '';
            const was = p.compare_at_price > p.price ? '<s>' + this.money(p.compare_at_price) + '</s>' : '';
            const many = (p.variants || []).length > 1;
            const btn = many ? '<a class="pkc__radd" href="' + this.esc(p.url) + '">Choose</a>' : '<button type="button" class="pkc__radd" data-pkc-radd="' + (v ? v.id : '') + '">' + this.esc(this.dataset.recoBtn) + '</button>';
            return '<div class="pkc__rcard">' + (img ? '<a href="' + this.esc(p.url) + '"><img src="' + this.esc(img) + '" alt="' + this.esc(p.title) + '" loading="lazy"></a>' : '<span></span>')
              + '<div><a class="pkc__rname" href="' + this.esc(p.url) + '">' + this.esc(p.title) + '</a><div class="pkc__rrow"><span class="pkc__rprice">' + was + this.money(p.price) + '</span>' + btn + '</div></div></div>';
          }).join('');
          this.recoEl.hidden = false;
        };
        if (this.recoCache[pid]) { show(this.recoCache[pid]); return; }
        fetch((this.dataset.recoUrl || '/recommendations/products') + '.json?product_id=' + pid + '&limit=' + (limit + cart.items.length) + '&intent=related')
          .then((r) => r.json()).then((j) => { this.recoCache[pid] = j.products || []; show(this.recoCache[pid]); })
          .catch(() => { this.recoEl.hidden = true; });
      }

      addReco(btn) {
        if (btn.getAttribute('aria-busy') === 'true' || !btn.dataset.pkcRadd) return;
        btn.setAttribute('aria-busy', 'true');
        fetch(this.dataset.root.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.pkcRadd), quantity: 1 }] })
        })
          .then((r) => (r.ok ? r.json() : Promise.reject()))
          .then(() => { document.dispatchEvent(new CustomEvent('cart:update', { detail: { fromPkc: true } })); return this.refresh(); })
          .catch(() => { btn.removeAttribute('aria-busy'); });
      }

      onBody(e) {
        const b = e.target.closest('[data-act]');
        if (!b) return;
        const li = b.closest('.pkc__item');
        const item = this.cart && this.cart.items.find((x) => x.key === li.dataset.key);
        if (!item) return;
        const q = b.dataset.act === 'inc' ? item.quantity + 1 : b.dataset.act === 'dec' ? item.quantity - 1 : 0;
        this.change(li, item.key, Math.max(q, 0));
      }

      change(li, key, quantity) {
        li.classList.add('is-busy');
        fetch(this.cartUrl.replace(/\/$/, '') + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        })
          .then((r) => (r.ok ? r.json() : Promise.reject()))
          .then((cart) => this.withMrp(cart))
          .then((cart) => {
            this.render(cart);
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, fromPkc: true } }));   /* header ka count update */
          })
          .catch(() => this.refresh());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-collection-page')) {
    customElements.define('pk-collection-page', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.pkpc__drawer');
        this.openBtn = this.querySelector('[data-pkpc-open]');
        if (this.openBtn) this.openBtn.addEventListener('click', () => this.toggle(true));
        this.querySelectorAll('[data-pkpc-close]').forEach((el) => el.addEventListener('click', () => this.toggle(false)));
        this.onKey = (e) => { if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.toggle(false); };
        document.addEventListener('keydown', this.onKey);
        const sort = this.querySelector('[data-pkpc-sort]');
        if (sort) sort.addEventListener('change', () => { const f = sort.form; if (f) (f.requestSubmit ? f.requestSubmit() : f.submit()); });
        const form = this.querySelector('.pkpc__form');
        if (form) form.addEventListener('formdata', (e) => { for (const [k, v] of Array.from(e.formData.entries())) if (v === '') e.formData.delete(k); });
      }
      disconnectedCallback() { document.removeEventListener('keydown', this.onKey); document.documentElement.style.overflow = ''; }
      toggle(open) {
        this.drawer.classList.toggle('is-open', open);
        this.drawer.setAttribute('aria-hidden', String(!open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) { const c = this.drawer.querySelector('.pkpc__close'); c && c.focus(); } else if (this.openBtn) this.openBtn.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-community')) {
    customElements.define('pk-community', class extends HTMLElement {
      connectedCallback() {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.target === this) { if (e.isIntersecting) this.classList.add('is-in'); return; }
            const v = e.target;
            if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
          });
        }, { threshold: 0.35 });
        this.io.observe(this);
        this.querySelectorAll('video').forEach((v) => { v.muted = true; this.io.observe(v); });
      }
      disconnectedCallback() { this.io && this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function go() {
      var note = document.querySelector('[data-pkpt-focus]');
      if (note) { note.scrollIntoView({ block: 'center' }); note.focus({ preventScroll: true }); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-faq-page')) {
    customElements.define('pk-faq-page', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-pkpf-item]'));
        this.search = this.querySelector('[data-pkpf-search]');
        this.empty = this.querySelector('[data-pkpf-empty]');
        this.cat = 'all';
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.items.forEach((item) => item.querySelector('summary').addEventListener('click', (e) => { e.preventDefault(); this.toggle(item); }));
        this.querySelectorAll('[data-pkpf-cat]').forEach((chip) => chip.addEventListener('click', () => {
          this.cat = chip.dataset.pkpfCat;
          this.querySelectorAll('[data-pkpf-cat]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          this.filter();
        }));
        if (this.search) this.search.addEventListener('input', () => this.filter());
      }
      toggle(item, force) {
        const open = force !== undefined ? force : !item.open;
        if (open === item.open) return;
        const panel = item.querySelector('.pkpf__a');
        if (open && this.dataset.single === 'true') this.items.forEach((i) => { if (i !== item && i.open) this.toggle(i, false); });
        if (this.reduce || !panel.animate) { item.open = open; return; }
        if (open) { item.open = true; panel.animate([{ height: '0px' }, { height: panel.scrollHeight + 'px' }], { duration: 280, easing: 'cubic-bezier(.2,.8,.2,1)' }); }
        else { const a = panel.animate([{ height: panel.scrollHeight + 'px' }, { height: '0px' }], { duration: 200, easing: 'ease' }); a.onfinish = () => { item.open = false; }; }
      }
      filter() {
        const q = this.search ? this.search.value.trim().toLowerCase() : '';
        let shown = 0;
        this.items.forEach((item) => {
          const ok = (this.cat === 'all' || item.dataset.cat === this.cat) && (!q || item.textContent.toLowerCase().includes(q));
          item.hidden = !ok; if (ok) shown += 1;
        });
        if (this.empty) this.empty.hidden = shown > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-header"]) return;
  try {
    
  if (!customElements.get('pk-header')) {
    customElements.define('pk-header', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.pkh1__drawer');
        this.openBtn = this.querySelector('[data-pkh1-open]');
        this.openBtn && this.openBtn.addEventListener('click', () => this.toggle(true));
        this.querySelectorAll('[data-pkh1-close]').forEach((el) => el.addEventListener('click', () => this.toggle(false)));
        this.onKey = (e) => { if (e.key === 'Escape') this.toggle(false); };
        this.onCart = (e) => {
          const r = e.detail && e.detail.resource;
          if (r && typeof r.item_count === 'number') return this.setCount(r.item_count);
          fetch(this.dataset.cartUrl + '.js').then((x) => x.json()).then((c) => this.setCount(c.item_count)).catch(() => {});
        };
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('cart:update', this.onCart);
        if (this.classList.contains('is-sticky')) this.setupSticky();
        // mega menu: hovering or focusing a sub-collection shows its products
        this.querySelectorAll('[data-pkh1-mega]').forEach((mega) => {
          const tabs = mega.querySelectorAll('[data-pkh1-tab]');
          const panels = mega.querySelectorAll('[data-pkh1-panel]');
          const show = (i) => {
            tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.pkh1Tab === i));
            panels.forEach((p) => p.classList.toggle('is-active', p.dataset.pkh1Panel === i));
          };
          tabs.forEach((tab) => {
            tab.addEventListener('mouseenter', () => show(tab.dataset.pkh1Tab));
            tab.addEventListener('focus', () => show(tab.dataset.pkh1Tab));
          });
        });
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey); document.removeEventListener('cart:update', this.onCart);
        if (this.stickyIO) this.stickyIO.disconnect();
        window.removeEventListener('resize', this.onBarResize);
      }
      setupSticky() {
        const sentinel = this.querySelector('[data-pkh1-sentinel]');
        const bar = this.querySelector('.pkh1__bar');
        if (!sentinel || !bar) return;
        // Wrappers with transform / filter / contain would trap a fixed bar inside them (Horizon quirk)
        let el = this.parentElement;
        while (el && el !== document.body) {
          const cs = getComputedStyle(el);
          if (cs.transform !== 'none') el.style.transform = 'none';
          if (cs.filter !== 'none') el.style.filter = 'none';
          if (cs.contain && cs.contain !== 'none') el.style.contain = 'none';
          if (cs.containerType && cs.containerType !== 'normal') el.style.containerType = 'normal';
          if (cs.overflow === 'hidden' || cs.overflowY === 'hidden') el.style.overflow = 'visible';
          el = el.parentElement;
        }
        this.onBarResize = () => { if (!this.classList.contains('is-stuck')) this.style.setProperty('--pkh1-bar-h', bar.offsetHeight + 'px'); };
        this.onBarResize();
        window.addEventListener('resize', this.onBarResize);
        this.stickyIO = new IntersectionObserver(([e]) => {
          const stuck = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (stuck && !this.classList.contains('is-stuck')) { this.style.setProperty('--pkh1-bar-h', bar.offsetHeight + 'px'); this.classList.add('is-stuck'); }
          else if (!stuck) this.classList.remove('is-stuck');
        }, { threshold: 0 });
        this.stickyIO.observe(sentinel);
      }
      toggle(open) {
        if (!this.drawer) return;
        this.drawer.classList.toggle('is-open', open);
        this.drawer.setAttribute('aria-hidden', String(!open));
        this.openBtn.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      setCount(n) {
        const c = this.querySelector('[data-cart-count]');
        if (c) { c.textContent = n; c.hidden = n === 0; }
        const l = this.querySelector('[data-pkh1-cart]'); if (l) l.setAttribute('aria-label', 'Cart, ' + n + ' items');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pkoFlip) return; window.__pkoFlip = true;
    document.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches) return;
      var flip = e.target.closest('[data-pko-flip]');
      document.querySelectorAll('[data-pko-flip].is-flipped').forEach(function (f) { if (f !== flip) f.classList.remove('is-flipped'); });
      if (!flip || e.target.closest('.pko__cta')) return;
      flip.classList.toggle('is-flipped');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-offers-page')) {
    customElements.define('pk-offers-page', class extends HTMLElement {
      connectedCallback() {
        const o1 = { qty: parseInt(this.dataset.q1, 10) || 3, price: parseInt(this.dataset.p1, 10) || 0 };
        const o2 = { qty: parseInt(this.dataset.q2, 10) || 4, price: parseInt(this.dataset.p2, 10) || 0 };
        const mode = this.dataset.mode || 'flexible';
        /* tiers that count on this page, smallest first */
        this.tiers = mode === 'offer1' ? [o1] : mode === 'offer2' ? [o2] : [o1, o2].sort((a, b) => a.qty - b.qty);
        this.min = this.tiers[0].qty;
        this.max = this.tiers[this.tiers.length - 1].qty;
        this.picks = [];   /* one entry per product: { pid, vid, price, mrp, title, img } */
        this.currency = this.dataset.currency || 'INR';
        this.slots = this.querySelector('[data-pkof-slots]');
        this.msg = this.querySelector('[data-pkof-msg]');
        this.addBtn = this.querySelector('[data-pkof-add]');

        this.addEventListener('click', (e) => {
          const pick = e.target.closest('[data-pkof-pick]');
          if (pick) { this.toggle(pick.closest('[data-pkof-item]')); return; }
          const x = e.target.closest('[data-pkof-unpick]');
          if (x) this.remove(x.dataset.pkofUnpick);
        });
        this.addEventListener('change', (e) => {
          const sel = e.target.closest('[data-pkof-var]');
          if (!sel) return;
          const li = sel.closest('[data-pkof-item]'), opt = sel.selectedOptions[0];
          li.dataset.vid = sel.value; li.dataset.price = opt.dataset.price; li.dataset.mrp = opt.dataset.mrp;
          const p = this.picks.find((x) => x.pid === li.dataset.pid);
          if (p) { p.vid = li.dataset.vid; p.price = +li.dataset.price; p.mrp = +li.dataset.mrp; }
          const priceEl = li.querySelector('.pkof__price');
          if (priceEl) priceEl.innerHTML = '<span>' + this.money(+opt.dataset.price) + '</span>' + (+opt.dataset.mrp > +opt.dataset.price ? '<s>' + this.money(+opt.dataset.mrp) + '</s>' : '');
        });
        this.addBtn.addEventListener('click', () => this.addBundle());
        this.render();
      }

      money(cents) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2); }
      }
      esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      tierFor(n) { return this.tiers.filter((t) => t.qty <= n).pop() || null; }

      mark(pid, on) {
        const li = this.querySelector('[data-pkof-item][data-pid="' + pid + '"]');
        if (!li) return;
        li.classList.toggle('is-picked', on);
        const b = li.querySelector('[data-pkof-pick]');
        if (b) { b.setAttribute('aria-pressed', String(on)); b.textContent = on ? (this.dataset.remove || 'Remove') : (this.dataset.add || 'Add to bundle'); }
      }

      toggle(li) {
        if (!li || li.classList.contains('is-out')) return;
        const pid = li.dataset.pid;
        if (this.picks.some((p) => p.pid === pid)) { this.remove(pid); return; }
        if (this.picks.length >= this.max) {
          this.msg.textContent = 'Bundle full · remove one to swap'; this.msg.classList.add('is-warn');
          li.classList.remove('is-shake'); void li.offsetWidth; li.classList.add('is-shake');
          clearTimeout(this.warnT); this.warnT = setTimeout(() => this.render(), 2200);
          return;
        }
        this.picks.push({ pid, vid: li.dataset.vid, price: +li.dataset.price, mrp: +li.dataset.mrp, title: li.dataset.title, img: li.dataset.img });
        this.mark(pid, true);
        this.render();
      }

      remove(pid) {
        this.picks = this.picks.filter((p) => p.pid !== pid);
        this.mark(pid, false);
        this.render();
      }

      render() {
        const n = this.picks.length, tier = this.tierFor(n), next = this.tiers.find((t) => t.qty > n);
        let html = '';
        for (let i = 0; i < this.max; i++) {
          const p = this.picks[i];
          const bonus = i >= this.min;   /* optional slot that upgrades the deal */
          if (p) html += '<span class="pkof__slot is-full' + (bonus ? ' is-bonus' : '') + '">' + (p.img ? '<img src="' + this.esc(p.img) + '" alt="' + this.esc(p.title) + '">' : '') + '<button type="button" class="pkof__slot-x" data-pkof-unpick="' + this.esc(p.pid) + '" aria-label="Remove ' + this.esc(p.title) + '">×</button></span>';
          else if (bonus && next && tier) html += '<span class="pkof__slot is-bonus" aria-hidden="true">+' + this.esc(this.money(next.price - tier.price)) + '</span>';
          else html += '<span class="pkof__slot' + (bonus ? ' is-bonus' : '') + '" aria-hidden="true">+</span>';
        }
        this.slots.innerHTML = html;
        this.msg.classList.remove('is-warn');
        if (!tier) {
          const left = this.min - n;
          this.msg.innerHTML = 'Pick ' + left + ' more · bundle at <b>' + this.money(this.tiers[0].price) + '</b>';
        } else if (next) {
          const more = next.qty - n;
          this.msg.innerHTML = '<b>' + this.money(tier.price) + '</b> unlocked 🎉 +' + this.money(next.price - tier.price) + ' for ' + next.qty + ' @ <b>' + this.money(next.price) + '</b>';
        } else {
          this.msg.innerHTML = 'Best deal: <b>' + tier.qty + ' @ ' + this.money(tier.price) + '</b> 🎉';
        }
        this.addBtn.disabled = !tier;
        this.addBtn.textContent = tier ? 'Add ' + n + ' for ' + this.money(tier.price) : 'Add ' + this.min + ' items';
      }

      addBundle() {
        const n = this.picks.length;
        if (!this.tierFor(n) || this.addBtn.getAttribute('aria-busy') === 'true') return;
        this.addBtn.setAttribute('aria-busy', 'true'); this.addBtn.textContent = 'Adding…';
        fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.picks.map((p) => ({ id: Number(p.vid), quantity: 1 })) })
        })
          .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw j; return j; }))
          .then(() => {
            this.addBtn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'product-form-component', itemCount: n } } }));
            setTimeout(() => { this.picks.forEach((p) => this.mark(p.pid, false)); this.picks = []; this.addBtn.removeAttribute('aria-busy'); this.render(); }, 1200);
          })
          .catch((err) => {
            this.addBtn.removeAttribute('aria-busy'); this.render();
            this.msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.'; this.msg.classList.add('is-warn');
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-reviews')) {
    customElements.define('pk-reviews', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-pkrv-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-pkrv-dot]'));
        if (!this.cards.length) return;
        this.i = 0;
        const prev = this.querySelector('[data-pkrv-prev]'), next = this.querySelector('[data-pkrv-next]');
        prev && prev.addEventListener('click', () => this.go(this.i - 1));
        next && next.addEventListener('click', () => this.go(this.i + 1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.pkrvDot)));
        this.cards.forEach((c, n) => c.addEventListener('click', () => { if (this.swiped) { this.swiped = false; return; } if (n !== this.i) this.go(n); }));
        const stage = this.querySelector('[data-pkrv-stage]');
        let x0 = null;
        stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        stage.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) { this.swiped = true; this.go(this.i + (dx < 0 ? 1 : -1)); setTimeout(() => { this.swiped = false; }, 50); } });
        this.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') this.go(this.i + 1); if (e.key === 'ArrowLeft') this.go(this.i - 1); });
        this.hover = false; this.visible = false;
        this.addEventListener('mouseenter', () => { this.hover = true; });
        this.addEventListener('mouseleave', () => { this.hover = false; });
        this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; });
        this.io.observe(this);
        if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = setInterval(() => { if (this.visible && !this.hover && !document.hidden) this.go(this.i + 1); }, 5000);
        }
        this.go(Math.floor(this.cards.length / 2));
      }
      disconnectedCallback() { clearInterval(this.timer); this.io && this.io.disconnect(); }
      go(n) {
        const len = this.cards.length;
        this.i = ((n % len) + len) % len;
        this.cards.forEach((c, k) => {
          let rel = k - this.i;
          if (rel > len / 2) rel -= len;
          if (rel < -len / 2) rel += len;
          c.dataset.pos = Math.abs(rel) <= 2 ? String(rel) : 'out';
          c.setAttribute('aria-hidden', String(rel !== 0));
          c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', rel === 0 ? '0' : '-1'));
        });
        this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.i); d.setAttribute('aria-current', String(k === this.i)); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-routine')) {
    customElements.define('pk-routine', class extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-pkrt-step]'));
        this.desc = this.querySelector('[data-pkrt-desc]');
        this.prod = this.querySelector('[data-pkrt-prod]');
        this.steps.forEach((st) => st.addEventListener('click', () => this.select(st)));
        this.addEventListener('keydown', (e) => {
          const i = this.steps.indexOf(document.activeElement);
          if (i < 0) return;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); const n = this.steps[(i + 1) % this.steps.length]; n.focus(); this.select(n); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); const n = this.steps[(i - 1 + this.steps.length) % this.steps.length]; n.focus(); this.select(n); }
        });
        const add = this.querySelector('[data-pkrt-add]');
        add && add.addEventListener('click', () => this.addAll(add));
        if (this.steps[0]) this.select(this.steps[0]);
      }
      select(st) {
        this.steps.forEach((x) => { const on = x === st; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', String(on)); });
        if (this.desc && st.dataset.text) this.desc.textContent = st.dataset.text;
        if (!this.prod) return;
        if (st.dataset.pTitle) {
          this.prod.hidden = false;
          this.prod.href = st.dataset.pUrl;
          this.prod.querySelector('[data-pkrt-ptitle]').textContent = st.dataset.pTitle;
          this.prod.querySelector('[data-pkrt-pprice]').textContent = st.dataset.pPrice;
          const img = this.prod.querySelector('[data-pkrt-img]');
          if (st.dataset.pImg) { img.src = st.dataset.pImg; img.hidden = false; } else { img.hidden = true; }
        } else { this.prod.hidden = true; }
      }
      addAll(btn) {
        const items = (this.dataset.ids || '').split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
        if (!items.length || btn.getAttribute('aria-busy') === 'true') return;
        const label = btn.textContent, status = this.querySelector('[data-pkrt-status]');
        btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding routine…';
        fetch(this.dataset.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
          .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw j; return j; }))
          .then(() => {
            btn.textContent = 'Routine added ✓'; if (status) status.textContent = 'Routine added to cart';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'product-form-component', itemCount: items.length } } }));
          })
          .catch((err) => { btn.textContent = 'Try again'; if (status) status.textContent = (err && (err.description || err.message)) || 'Could not add'; })
          .finally(() => setTimeout(() => { btn.textContent = label; btn.removeAttribute('aria-busy'); }, 1800));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-vibes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Long words (e.g. "ACCESSORIES") shrink only on their own card until they fit next to the arrow.
    function fit() {
      document.querySelectorAll('.pkv__text').forEach(function (t) {
        t.style.fontSize = '';
        var fs = parseFloat(getComputedStyle(t).fontSize);
        while (t.scrollWidth > t.clientWidth + 1 && fs > 15) { fs -= 1; t.style.fontSize = fs + 'px'; }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 150); });
    document.addEventListener('shopify:section:load', fit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-why"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-meet')) {
    customElements.define('pk-meet', class extends HTMLElement {
      connectedCallback() {
        this.buddy = this.querySelector('[data-pkm2-buddy]');
        this.bubble = this.querySelector('[data-pkm2-bubble]');
        this.pupil = this.querySelector('[data-pkm2-pupil]');
        this.lines = (this.dataset.lines || '').split(/\n/).map((l) => l.trim()).filter(Boolean);
        this.n = 0;
        if (this.buddy) this.buddy.addEventListener('click', () => this.talk());

        // eyes follow the pointer (mouse only, only while on screen)
        this.visible = false;
        this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; });
        this.io.observe(this);
        this.onMove = (e) => {
          if (!this.visible || !this.pupil || this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const r = this.buddy.getBoundingClientRect();
            const dx = e.clientX - (r.left + r.width * 0.4), dy = e.clientY - (r.top + r.height * 0.56);
            const d = Math.hypot(dx, dy) || 1, k = Math.min(1, d / 260) * 3.2;
            this.pupil.style.transform = `translate(${(dx / d) * k}px, ${(dy / d) * k}px)`;
          });
        };
        if (window.matchMedia('(hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.addEventListener('pointermove', this.onMove, { passive: true });
        }
      }
      disconnectedCallback() { window.removeEventListener('pointermove', this.onMove); this.io && this.io.disconnect(); }
      talk() {
        this.buddy.classList.remove('is-squish'); void this.buddy.offsetWidth; this.buddy.classList.add('is-squish');
        if (!this.bubble || this.lines.length < 2) return;
        this.n = (this.n + 1) % this.lines.length;
        this.bubble.textContent = this.lines[this.n];
        this.bubble.classList.add('is-pop');
        setTimeout(() => this.bubble.classList.remove('is-pop'), 250);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pookee-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pookee-contact')) {
    customElements.define('pookee-contact', class extends HTMLElement {
      connectedCallback() {
        // After sending, bring the success / error message into view
        const note = this.querySelector('[data-pkc-focus]');
        if (note) requestAnimationFrame(() => { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); note.focus({ preventScroll: true }); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pookee-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pookee-faq')) {
    customElements.define('pookee-faq', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-pkq-item]'));
        this.search = this.querySelector('[data-pkq-search]');
        this.empty = this.querySelector('[data-pkq-empty]');
        this.cat = 'all';
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.items.forEach((item) => {
          item.querySelector('summary').addEventListener('click', (e) => { e.preventDefault(); this.toggle(item); });
        });
        this.querySelectorAll('[data-pkq-cat]').forEach((chip) => {
          chip.addEventListener('click', () => {
            this.cat = chip.dataset.pkqCat;
            this.querySelectorAll('[data-pkq-cat]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
            this.filter();
          });
        });
        if (this.search) this.search.addEventListener('input', () => this.filter());
      }

      toggle(item, force) {
        const open = force !== undefined ? force : !item.open;
        if (open === item.open) return;
        const panel = item.querySelector('.pkq__a');
        if (open && this.dataset.single === 'true') this.items.forEach((i) => { if (i !== item && i.open) this.toggle(i, false); });
        if (this.reduce || !panel.animate) { item.open = open; return; }
        if (open) {
          item.open = true;
          const h = panel.scrollHeight;
          panel.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 280, easing: 'cubic-bezier(.2,.8,.2,1)' });
        } else {
          const h = panel.scrollHeight;
          const anim = panel.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 220, easing: 'ease' });
          anim.onfinish = () => { item.open = false; };
        }
      }

      filter() {
        const q = this.search ? this.search.value.trim().toLowerCase() : '';
        let shown = 0;
        this.items.forEach((item) => {
          const okCat = this.cat === 'all' || item.dataset.cat === this.cat;
          const okText = !q || item.textContent.toLowerCase().includes(q);
          item.hidden = !(okCat && okText);
          if (!item.hidden) shown += 1;
        });
        if (this.empty) this.empty.hidden = shown > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pookee-header"]) return;
  try {
    
  if (!customElements.get('pookee-header-v2')) {
    const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const formatMoney = (cents, format) => {
      format = String(format || '').replace(/<[^>]*>/g, '');
      const re = /\{\{\s*(\w+)\s*\}\}/;
      const fmt = (n, prec, th = ',', dec = '.') => {
        const parts = (n / 100).toFixed(prec).split('.');
        return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
      };
      const m = format.match(re);
      let v;
      switch (m ? m[1] : 'amount') {
        case 'amount_no_decimals': v = fmt(cents, 0); break;
        case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
        case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
        default: v = fmt(cents, 2);
      }
      return m ? format.replace(re, v) : v;
    };

    const sizedImage = (url, w) => {
      if (!url) return '';
      try { const u = new URL(url, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    };

    class PookeeHeaderV2 extends HTMLElement {
      connectedCallback() {
        this.menu = this.querySelector('.pkh-menu');
        this.openBtn = this.querySelector('[data-pkh-open]');
        this.cartLink = this.querySelector('[data-pkh-cart]');
        this.drawer = this.querySelector('.pkh-cart');
        this.useDrawer = this.dataset.cartType === 'drawer' && !!this.drawer;
        this.lastFocus = null;

        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          if (this.drawer && this.drawer.classList.contains('is-open')) this.closeCart();
          else if (this.menu && this.menu.classList.contains('is-open')) this.close();
        };
        this.bar = this.querySelector('.pkh__bar');
        this.holdSpace = () => {
          if (this.classList.contains('is-overlay') || this.classList.contains('is-scrolled')) return;
          this.style.minHeight = this.bar.offsetHeight + 'px';
          if (this.sentinel) this.sentinel.style.top = Math.max(40, this.bar.offsetHeight) + 'px';
        };
        this.onCart = (e) => this.handleCartEvent(e);

        if (this.menu && this.openBtn) {
          this.openBtn.addEventListener('click', () => this.open());
          this.menu.querySelectorAll('[data-pkh-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        }
        if (this.useDrawer) {
          this.body = this.drawer.querySelector('[data-pkh-cart-body]');
          this.cartLink.addEventListener('click', (e) => { e.preventDefault(); this.openCart(); });
          this.cartLink.addEventListener('pointerenter', () => { if (!this.cart) this.refresh(); }, { once: true });
          this.drawer.querySelectorAll('[data-pkh-cart-close]').forEach((el) => el.addEventListener('click', () => this.closeCart()));
          this.body.addEventListener('click', (e) => this.onBodyClick(e));
        }
        document.addEventListener('keydown', this.onKey);
        if (this.classList.contains('is-sticky')) this.setupSticky();
        document.addEventListener('cart:update', this.onCart);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('resize', this.holdSpace);
        if (this.io) this.io.disconnect();
        if (this.sentinel) this.sentinel.remove();
        document.removeEventListener('cart:update', this.onCart);
        document.documentElement.style.overflow = '';
      }

      /* ---------- Sticky ---------- */
      setupSticky() {
        this.sentinel = document.createElement('div');
        this.sentinel.setAttribute('aria-hidden', 'true');
        this.sentinel.style.cssText = 'position:absolute;left:0;top:40px;width:1px;height:1px;pointer-events:none;visibility:hidden;';
        this.appendChild(this.sentinel);
        this.holdSpace();
        window.addEventListener('resize', this.holdSpace);
        this.io = new IntersectionObserver(([entry]) => {
          const scrolled = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-scrolled', scrolled);
          if (scrolled && !this.ancestorsFixed) {
            requestAnimationFrame(() => {
              const top = this.bar.getBoundingClientRect().top;
              if (top < -5 || top > 40) { this.fixAncestors(); this.ancestorsFixed = true; }
            });
          }
        });
        this.io.observe(this.sentinel);
      }
      // A wrapper with transform / filter / containment pins a "fixed" bar to the wrapper instead of the screen.
      fixAncestors() {
        let el = this.parentElement;
        while (el && el !== document.body && el !== document.documentElement) {
          const cs = getComputedStyle(el);
          const breaksFixed = cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none' ||
            (cs.backdropFilter && cs.backdropFilter !== 'none') || /paint|layout|strict|content/.test(cs.contain || '') ||
            /transform|filter|perspective/.test(cs.willChange || '') || (cs.containerType && cs.containerType !== 'normal');
          if (breaksFixed) {
            ['transform', 'filter', 'perspective', 'backdrop-filter', 'contain'].forEach((p) => el.style.setProperty(p, 'none', 'important'));
            el.style.setProperty('will-change', 'auto', 'important');
            el.style.setProperty('container-type', 'normal', 'important');
          }
          el = el.parentElement;
        }
      }

      /* ---------- Menu ---------- */
      open() {
        this.menu.classList.add('is-open');
        this.menu.setAttribute('aria-hidden', 'false');
        this.openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        const c = this.menu.querySelector('.pkh__close'); c && c.focus();
      }
      close() {
        this.menu.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        this.openBtn.focus();
      }

      /* ---------- Cart count ---------- */
      setCount(n) {
        const count = this.querySelector('[data-cart-count]');
        const bag = this.querySelector('.pkh__bag');
        if (count) { count.textContent = n; count.hidden = n === 0; }
        if (bag) bag.hidden = n > 0;
        if (this.cartLink) this.cartLink.setAttribute('aria-label', 'Cart, ' + n + ' items');
        const q = this.querySelector('[data-pkh-cart-qty]');
        if (q) q.textContent = n > 0 ? '(' + n + ')' : '';
      }

      handleCartEvent(e) {
        const d = (e && e.detail) || {};
        if (d.data && d.data.source === 'pookee-cart-drawer') return;
        const res = d.resource;
        const hasCart = res && Array.isArray(res.items);
        const after = () => {
          if (this.useDrawer && this.dataset.cartAutoOpen === 'true' && !this.drawer.classList.contains('is-open')) this.openCart(true);
        };
        if (hasCart) { this.cart = res; this.setCount(res.item_count); this.render(); after(); }
        else this.refresh().then(after);
      }

      /* ---------- Cart drawer ---------- */
      openCart(skipFetch) {
        if (!this.useDrawer) return;
        this.lastFocus = document.activeElement;
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        if (!this.cart) this.body.innerHTML = '<p class="pkh-cart__meta" style="padding:24px 0">Loading…</p>';
        else this.render();
        if (!skipFetch) this.refresh();
        const c = this.drawer.querySelector('.pkh__close'); c && c.focus();
      }
      closeCart() {
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        (this.lastFocus && this.lastFocus.focus ? this.lastFocus : this.cartLink).focus();
      }

      refresh() {
        return fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => { this.cart = cart; this.setCount(cart.item_count); this.render(); return cart; })
          .catch(() => {});
      }

      change(key, quantity) {
        this.showError('');
        this.body.setAttribute('aria-busy', 'true');
        return fetch(this.dataset.cartChangeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        })
          .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw j; return j; }))
          .then((cart) => {
            this.cart = cart; this.setCount(cart.item_count); this.render();
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.id || 'pookee-header', data: { source: 'pookee-cart-drawer', itemCount: cart.item_count } } }));
          })
          .catch((err) => { this.showError((err && (err.description || err.message)) || 'Something went wrong. Please try again.'); this.refresh(); })
          .finally(() => this.body.removeAttribute('aria-busy'));
      }

      onBodyClick(e) {
        const btn = e.target.closest('[data-key]');
        if (!btn) return;
        const key = btn.dataset.key;
        const item = this.cart && this.cart.items.find((i) => i.key === key);
        if (!item) return;
        if (btn.hasAttribute('data-remove')) this.change(key, 0);
        else this.change(key, Math.max(0, item.quantity + Number(btn.dataset.step)));
      }

      showError(msg) {
        const el = this.drawer.querySelector('[data-pkh-cart-error]');
        el.textContent = msg; el.hidden = !msg;
      }

      render() {
        if (!this.useDrawer || !this.cart) return;
        const cart = this.cart, fmtStr = this.dataset.moneyFormat, money = (c) => formatMoney(c, fmtStr);
        const foot = this.drawer.querySelector('[data-pkh-cart-foot]');
        if (!cart.items.length) {
          this.body.innerHTML = this.drawer.querySelector('[data-pkh-cart-empty]').innerHTML;
          foot.hidden = true;
          return;
        }
        this.body.innerHTML = cart.items.map((item) => {
          const opts = (item.options_with_values || []).filter((o) => o.value !== 'Default Title').map((o) => esc(o.value)).join(' / ');
          const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? esc(item.selling_plan_allocation.selling_plan.name) : '';
          const was = item.original_line_price > item.final_line_price ? '<span class="pkh-cart__was">' + money(item.original_line_price) + '</span>' : '';
          const img = item.image ? '<img src="' + esc(sizedImage(item.image, 180)) + '" alt="" width="76" height="76" loading="lazy">' : '';
          return '<div class="pkh-cart__item">' +
            '<a class="pkh-cart__img" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div><a class="pkh-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              (opts ? '<span class="pkh-cart__meta">' + opts + '</span>' : '') +
              (plan ? '<span class="pkh-cart__meta">' + plan + '</span>' : '') +
              '<div class="pkh-cart__qty">' +
                '<button type="button" class="pkh-cart__qbtn" data-key="' + esc(item.key) + '" data-step="-1" aria-label="Decrease quantity of ' + esc(item.product_title) + '">−</button>' +
                '<span class="pkh-cart__qnum" aria-label="Quantity">' + item.quantity + '</span>' +
                '<button type="button" class="pkh-cart__qbtn" data-key="' + esc(item.key) + '" data-step="1" aria-label="Increase quantity of ' + esc(item.product_title) + '">+</button>' +
              '</div></div>' +
            '<div class="pkh-cart__side"><span class="pkh-cart__price">' + was + money(item.final_line_price) + '</span>' +
              '<button type="button" class="pkh-cart__remove" data-key="' + esc(item.key) + '" data-remove aria-label="Remove ' + esc(item.product_title) + '">Remove</button></div>' +
          '</div>';
        }).join('');
        const save = cart.original_total_price - cart.total_price;
        const saveRow = this.drawer.querySelector('[data-pkh-cart-save]');
        saveRow.hidden = !(save > 0);
        if (save > 0) this.drawer.querySelector('[data-pkh-cart-save-amt]').textContent = '−' + money(save);
        this.drawer.querySelector('[data-pkh-cart-total]').textContent = money(cart.total_price);
        foot.hidden = false;
      }
    }
    customElements.define('pookee-header-v2', PookeeHeaderV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skin-pdp')) {
    customElements.define('skin-pdp', class SkinPdp extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
        this.fieldsets = [...this.querySelectorAll('[data-option-index]')];

        this.fieldsets.forEach((fs) => fs.addEventListener('change', () => this.onOptionChange()));
        this.querySelectorAll('[data-qty]').forEach((btn) =>
          btn.addEventListener('click', () => this.stepQty(btn.dataset.qty))
        );

        const form = this.querySelector('form[data-type="add-to-cart-form"]');
        const atc = this.querySelector('[data-atc]');
        if (form && atc) {
          if (form && atc) {
            form.addEventListener('submit', (e) => {
              e.preventDefault();
              if (atc.disabled || atc.classList.contains('is-loading')) return;
              const sticky = this.querySelector('[data-sticky-atc]');
              atc.classList.add('is-loading');
              if (sticky) sticky.classList.add('is-loading');
              const flyFrom = this.flyFrom || atc;
              this.flyFrom = null;
              const added = this.getAddedInfo(form);
              this.addToCart(new FormData(form))
                .then(() => {
                  try {
                    this.flyToCart(flyFrom, () => this.showAddedBubble(added));
                  } catch (err) { /* animation is optional */ }
                  this.refreshCartCount();
                })
                .catch(() => form.submit())
                .finally(() => {
                  atc.classList.remove('is-loading');
                  if (sticky) sticky.classList.remove('is-loading');
                });
            });
            window.addEventListener('pageshow', () => atc.classList.remove('is-loading'));
          }
          window.addEventListener('pageshow', () => atc.classList.remove('is-loading'));
        }

        this.initGallery();
        this.initSticky();
        if (this.fieldsets.length) this.refreshAvailability(this.getSelected());
      }

      getSelected() {
        return this.fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
      }

      onOptionChange() {
        const selected = this.getSelected();
        this.fieldsets.forEach((fs, i) => {
          const out = fs.querySelector('[data-option-value]');
          if (out) out.textContent = selected[i] ?? '';
        });
        const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        this.refreshAvailability(selected);
        this.update(variant);
      }

      refreshAvailability(selected) {
        this.fieldsets.forEach((fs, i) => {
          fs.querySelectorAll('input').forEach((input) => {
            const ok = this.variants.some((v) =>
              v.available && v.options[i] === input.value &&
              v.options.every((o, j) => j === i || o === selected[j])
            );
            input.closest('.hp-pill')?.classList.toggle('is-soldout', !ok);
          });
        });
      }

      update(v) {
        const atc = this.querySelector('[data-atc]');
        const atcText = this.querySelector('[data-atc-text]');

        if (!v) {
          if (atc) { atc.disabled = true; atcText.textContent = atc.dataset.unavailable; }
          const sbn = this.querySelector('[data-sticky-atc]');
          if (sbn) { sbn.disabled = true; this.querySelector('[data-sticky-atc-text]').textContent = 'Unavailable'; }
          return;
        }

        const idInput = this.querySelector('[data-variant-id]');
        if (idInput) {
          idInput.value = v.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        const price = this.querySelector('[data-price]');
        const compare = this.querySelector('[data-compare]');
        const save = this.querySelector('[data-save]');
        if (price) price.textContent = this.formatMoney(v.price);
        if (compare) {
          compare.hidden = !onSale;
          if (onSale) compare.textContent = this.formatMoney(v.compare_at_price);
        }
        if (save) {
          save.hidden = !onSale;
          if (onSale) {
            const pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
            save.textContent = save.dataset.template.replace('[percent]', pct);
          }
        }

        if (atc) {
          atc.disabled = !v.available;
          atcText.textContent = v.available ? atc.dataset.add : atc.dataset.soldout;
        }

        const sp = this.querySelector('[data-sticky-price]');
        if (sp) {
          sp.textContent = this.formatMoney(v.price);
          const sc = this.querySelector('[data-sticky-compare]');
          if (sc) { sc.hidden = !onSale; if (onSale) sc.textContent = this.formatMoney(v.compare_at_price); }
          const sv = this.querySelector('[data-sticky-var]');
          if (sv) sv.textContent = v.title;
          const sb = this.querySelector('[data-sticky-atc]');
          if (sb) { sb.disabled = !v.available; this.querySelector('[data-sticky-atc-text]').textContent = v.available ? sb.dataset.add : 'Sold out'; }
        }

        this.querySelectorAll('[data-size-auto]').forEach((el) => { el.textContent = v.options[0]; });

        if (this.dataset.updateUrl === 'true' && window.location.pathname.includes('/products/')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (v.featured_media) this.scrollToMedia(v.featured_media.id);
      }

      initSticky() {
        const bar = this.querySelector('[data-sticky]');
        const mainBtn = this.querySelector('[data-atc]');
        const form = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!bar || !mainBtn || !form || !('IntersectionObserver' in window)) return;
        const stickyBtn = bar.querySelector('[data-sticky-atc]');
        let mainOut = false, footerIn = false;
        const sync = () => {
          const show = mainOut && !footerIn;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          stickyBtn.tabIndex = show ? 0 : -1;
        };
        new IntersectionObserver(([e]) => { mainOut = !e.isIntersecting; sync(); }).observe(mainBtn);
        const footer = document.querySelector('footer');
        if (footer) new IntersectionObserver(([e]) => { footerIn = e.isIntersecting; sync(); }).observe(footer);
        stickyBtn.addEventListener('click', () => {
          if (stickyBtn.disabled || mainBtn.disabled) return;
          stickyBtn.classList.add('is-loading');
          this.flyFrom = stickyBtn;
          mainBtn.click(); /* same path as the main button */
          setTimeout(() => stickyBtn.classList.remove('is-loading'), 1500);
        });
        window.addEventListener('pageshow', () => stickyBtn.classList.remove('is-loading'));
      }

      addToCart(formData) {
        // XMLHttpRequest on purpose: the cart drawer watches fetch(/cart/add) and would pop open
        return new Promise((resolve, reject) => {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const xhr = new XMLHttpRequest();
          xhr.open('POST', root + 'cart/add.js');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(xhr));
          xhr.onerror = () => reject(xhr);
          xhr.send(formData);
        });
      }

      refreshCartCount() {
        // Tells the header cart icon (and the cart drawer contents) that the cart changed
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: this.id, data: { itemCount: cart.item_count, source: 'skin-pdp' } }
            }));
          })
          .catch(() => {});
      }

      findCartIcon() {
        const selectors = [
          'header a[href$="/cart"]',
          'header [aria-controls="cart-drawer"]',
          '[aria-controls="cart-drawer"]',
          'cart-icon',
          'a[href$="/cart"]'
        ];
        for (const sel of selectors) {
          for (const el of document.querySelectorAll(sel)) {
            const r = el.getBoundingClientRect();
            if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return el;
          }
        }
        return null;
      }

      flyToCart(fromEl, onLand) {
        const land = () => { if (typeof onLand === 'function') onLand(); };
        if (!fromEl) { land(); return; }
        const target = this.findCartIcon();
        const pop = () => {
          if (!target) return;
          target.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }],
            { duration: 450, easing: 'ease-out' }
          );
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { pop(); land(); return; }

        const from = fromEl.getBoundingClientRect();
        const sx = from.left + from.width / 2;
        const sy = from.top + from.height / 2;
        let ex = window.innerWidth - 32;
        let ey = 24; // header hidden on scroll: fly to the top-right corner
        if (target) {
          const t = target.getBoundingClientRect();
          ex = t.left + t.width / 2;
          ey = t.top + t.height / 2;
        }
        const cx = (sx + ex) / 2;
        const cy = Math.min(sy, ey) - 120;
        const size = 28;

        // Points along a curved path from the button to the cart icon
        const frames = [];
        const steps = 14;
        for (let i = 0; i <= steps; i++) {
          const p = i / steps;
          const x = (1 - p) * (1 - p) * sx + 2 * (1 - p) * p * cx + p * p * ex;
          const y = (1 - p) * (1 - p) * sy + 2 * (1 - p) * p * cy + p * p * ey;
          const scale = 1 - p * 0.65;
          frames.push({ transform: `translate(${x - size / 2}px, ${y - size / 2}px) scale(${scale})` });
        }

        const dot = document.createElement('span');
        dot.className = 'hp-fly-dot';
        dot.style.background = getComputedStyle(this).getPropertyValue('--hp-accent').trim() || '#E31D93';
        document.body.appendChild(dot);

        const anim = dot.animate(frames, { duration: 750, easing: 'ease-in-out' });
        anim.onfinish = () => { dot.remove(); pop(); land(); };
        anim.oncancel = () => { dot.remove(); land(); };
      }

      getAddedInfo(form) {
        const idInput = form.querySelector('[data-variant-id]');
        const id = Number(idInput ? idInput.value : 0);
        const v = this.variants.find((x) => x.id === id) || this.variants[0];
        if (!v) return null;
        const qtyInput = this.querySelector('[data-qty-input]');
        const qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
        const showVariant = v.title && v.title !== 'Default Title';
        let image = this.dataset.productImage || '';
        if (v.featured_image && v.featured_image.src) {
          const src = v.featured_image.src;
          image = src + (src.includes('?') ? '&' : '?') + 'width=120';
        }
        return {
          title: this.dataset.productTitle || '',
          meta: (showVariant ? v.title + ' · ' : '') + 'Qty ' + qty,
          price: this.formatMoney(v.price * qty),
          image
        };
      }

      showAddedBubble(info) {
        if (!info) return;
        if (this.hideAddedBubble) this.hideAddedBubble();

        const cs = getComputedStyle(this);
        const bubble = document.createElement('div');
        bubble.className = 'hp-added';
        bubble.setAttribute('role', 'status');
        bubble.setAttribute('aria-live', 'polite');
       bubble.style.setProperty('--hp-added-text', '#2B2B2B');
    bubble.style.setProperty('--hp-added-accent', '#2B2B2B');
        bubble.style.setProperty('--hp-added-border', cs.getPropertyValue('--hp-border').trim() || '#EBD4DB');
        bubble.style.setProperty('--hp-added-soft', cs.getPropertyValue('--hp-soft').trim() || '#F6D5DE');
        bubble.style.setProperty('--hp-added-font', cs.fontFamily);
        bubble.innerHTML =
          '<p class="hp-added__ok"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M6.3 10.3l2.4 2.4 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Added to your bag</span></p>' +
          '<div class="hp-added__row"><span class="hp-added__img"></span>' +
          '<div class="hp-added__body"><p class="hp-added__title"></p><p class="hp-added__meta"></p></div>' +
          '<span class="hp-added__price"></span></div>';
        bubble.querySelector('.hp-added__title').textContent = info.title;
        bubble.querySelector('.hp-added__meta').textContent = info.meta;
        bubble.querySelector('.hp-added__price').textContent = info.price;
        if (info.image) {
          const img = new Image(48, 48);
          img.src = info.image;
          img.alt = '';
          bubble.querySelector('.hp-added__img').appendChild(img);
        }
        document.body.appendChild(bubble);

        // Place the bubble under the cart icon, with the arrow pointing at the icon
        const icon = this.findCartIcon();
        let top = 12;
        let right = 12;
        let arrow = 16;
        if (icon) {
          const r = icon.getBoundingClientRect();
          top = r.bottom + 12;
          right = Math.max(12, window.innerWidth - r.right - 4);
          const iconCenterFromRight = window.innerWidth - (r.left + r.width / 2);
          arrow = Math.min(Math.max(iconCenterFromRight - right - 6, 12), bubble.offsetWidth - 24);
        }
        bubble.style.top = top + 'px';
        bubble.style.right = right + 'px';
        bubble.style.setProperty('--hp-added-arrow', arrow + 'px');
        requestAnimationFrame(() => bubble.classList.add('is-visible'));

        // Hide after 3 seconds, on a tap outside, or on scroll
        let timer = null;
        const onOutside = (e) => { if (!bubble.contains(e.target)) hide(); };
        const hide = () => {
          clearTimeout(timer);
          document.removeEventListener('pointerdown', onOutside, true);
          window.removeEventListener('scroll', hide);
          bubble.classList.remove('is-visible');
          setTimeout(() => bubble.remove(), 300);
          if (this.hideAddedBubble === hide) this.hideAddedBubble = null;
        };
        this.hideAddedBubble = hide;
        timer = setTimeout(hide, 3000);
        setTimeout(() => {
          document.addEventListener('pointerdown', onOutside, true);
          window.addEventListener('scroll', hide, { passive: true });
        }, 0);
      }

      stepQty(dir) {
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        const min = parseInt(input.min, 10) || 1;
        const val = parseInt(input.value, 10) || min;
        input.value = dir === 'plus' ? val + 1 : Math.max(min, val - 1);
      }

      initGallery() {
        this.track = this.querySelector('[data-track]');
        this.counter = this.querySelector('[data-counter]');
        if (!this.track) return;
        this.slides = [...this.track.querySelectorAll('[data-slide]')];

        const render = () => {
          if (!this.counter || this.slides.length < 2) return;
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          let idx = 0;
          this.slides.forEach((slide, i) => { if (slide.offsetLeft <= mid) idx = i; });
          this.counter.textContent = `${idx + 1} / ${this.slides.length}`;
        };

        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { ticking = false; render(); });
        }, { passive: true });
        render();
      }

      scrollToMedia(id) {
        const slide = this.querySelector(`[data-media-id="${id}"]`);
        if (!slide || !this.track || this.track.scrollWidth <= this.track.clientWidth) return;
        const left = slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
        this.track.scrollTo({ left, behavior: 'smooth' });
      }

      formatMoney(cents) {
        const value = Number(cents) / 100;
        const fmt = (decimals, thousands = ',', decimal = '.') => {
          const [int, dec] = value.toFixed(decimals).split('.');
          const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return dec ? grouped + decimal + dec : grouped;
        };
        const pattern = /\{\{\s*(\w+)\s*\}\}/;
        const match = this.moneyFormat.match(pattern);
        let out;
        switch (match && match[1]) {
          case 'amount_no_decimals': out = fmt(0); break;
          case 'amount_with_comma_separator': out = fmt(2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': out = fmt(0, '.', ','); break;
          case 'amount_with_apostrophe_separator': out = fmt(2, "'", '.'); break;
          case 'amount_with_space_separator': out = fmt(2, ' ', ','); break;
          default: out = fmt(2);
        }
        return this.moneyFormat.replace(pattern, out).replace(/<[^>]*>/g, '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.scroller = this.querySelector('.hp-tb__bar-scroll');
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => this.onKey(e, i));
        });

        // Theme editor: open the tab being edited
        this.onBlockSelect = (e) => {
          const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
          if (i > -1) this.select(i, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        const active = this.tabs.findIndex((t) => t.classList.contains('is-active'));
        this.keepInView(this.tabs[Math.max(active, 0)], false);

        // Mobile: hide the right-edge fade once the tab bar is scrolled to the end
        if (this.scroller) {
          this.updateFade = () => {
            const s = this.scroller;
            s.classList.toggle('is-end', s.scrollLeft + s.clientWidth >= s.scrollWidth - 4);
          };
          this.scroller.addEventListener('scroll', this.updateFade, { passive: true });
          window.addEventListener('resize', this.updateFade);
          this.updateFade();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.updateFade) window.removeEventListener('resize', this.updateFade);
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          this.panels[i].hidden = !on;
        });
        if (focus) this.tabs[index].focus();
        this.keepInView(this.tabs[index], true);
      }

      onKey(e, i) {
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }

      keepInView(tab, smooth) {
        if (!tab || !this.scroller || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
        const left = tab.offsetLeft - (this.scroller.clientWidth - tab.offsetWidth) / 2;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollTo({ left, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-story-card')) {
    class UgcStoryCard extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.bars = Array.from(this.querySelectorAll('[data-bar-fill]'));
        if (!this.slides.length) return;

        this.duration = (parseFloat(this.dataset.duration) || 5) * 1000;
        this.index = 0;
        this.elapsed = 0;
        this.running = false;
        this.inView = false;
        this.held = false;
        this.suppressClick = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tick = this.tick.bind(this);

        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.playsInline = true;
          video.loop = false;
          video.addEventListener('ended', () => {
            if (this.slides[this.index] === slide) this.next();
          });
          video.addEventListener('error', () => {
            slide.ugcTimed = true;
          });
        });

        this.bindEvents();
        this.show(0);

        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.inView ? this.play() : this.pause();
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.pause();
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      bindEvents() {
        this.querySelector('[data-prev]')?.addEventListener('click', () => {
          if (this.consumeClick()) return;
          this.prev();
        });
        this.querySelector('[data-next]')?.addEventListener('click', () => {
          if (this.consumeClick()) return;
          this.next();
        });

        this.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          this.suppressClick = false;
          this.startX = event.clientX;
          this.startY = event.clientY;
          clearTimeout(this.holdTimer);
          this.holdTimer = setTimeout(() => {
            this.held = true;
            this.classList.add('is-held');
            this.pause();
          }, 200);
        });

        this.addEventListener('pointermove', (event) => {
          if (Math.abs(event.clientX - this.startX) > 10 || Math.abs(event.clientY - this.startY) > 10) {
            clearTimeout(this.holdTimer);
          }
        });

        this.addEventListener('pointerup', () => this.release(true));
        this.addEventListener('pointercancel', () => this.release(false));
        this.addEventListener('pointerleave', () => this.release(false));
        this.addEventListener('contextmenu', (event) => event.preventDefault());

        this.onVisibility = () => (document.hidden ? this.pause() : this.play());
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      release(fromTap) {
        clearTimeout(this.holdTimer);
        if (!this.held) return;
        this.held = false;
        this.classList.remove('is-held');
        if (fromTap) this.suppressClick = true;
        this.play();
      }

      consumeClick() {
        if (!this.suppressClick) return false;
        this.suppressClick = false;
        return true;
      }

      currentSlide() {
        return this.slides[this.index];
      }

      currentVideo() {
        return this.currentSlide()?.querySelector('video') || null;
      }

      isTimed() {
        return !this.currentVideo() || this.currentSlide().ugcTimed;
      }

      setBar(i, progress) {
        const bar = this.bars[i];
        if (bar) bar.style.transform = `scaleX(${progress})`;
      }

      show(i) {
        const oldVideo = this.currentVideo();
        if (oldVideo) oldVideo.pause();

        this.index = i;
        this.elapsed = 0;
        this.last = performance.now();

        this.slides.forEach((slide, n) => {
          slide.classList.toggle('is-active', n === i);
          slide.setAttribute('aria-hidden', n === i ? 'false' : 'true');
        });
        this.bars.forEach((_, n) => this.setBar(n, n < i ? 1 : 0));

        const video = this.currentVideo();
        if (video) {
          try {
            video.currentTime = 0;
          } catch (e) {}
        }

        if (this.running) this.playMedia();
      }

      next() {
        this.show(this.index < this.slides.length - 1 ? this.index + 1 : 0);
      }

      prev() {
        this.show(this.index > 0 ? this.index - 1 : 0);
      }

      playMedia() {
        const video = this.currentVideo();
        if (!video || this.currentSlide().ugcTimed) return;
        const promise = video.play();
        if (promise) {
          promise.catch(() => {
            this.currentSlide().ugcTimed = true;
          });
        }
      }

      play() {
        if (this.running || !this.inView || this.held || this.reduced || document.hidden) return;
        this.running = true;
        this.last = performance.now();
        this.playMedia();
        this.raf = requestAnimationFrame(this.tick);
      }

      pause() {
        this.running = false;
        cancelAnimationFrame(this.raf);
        this.currentVideo()?.pause();
      }

      tick(now) {
        if (!this.running) return;
        const delta = now - this.last;
        this.last = now;

        let progress = 0;
        if (this.isTimed()) {
          this.elapsed += delta;
          progress = this.elapsed / this.duration;
        } else {
          const video = this.currentVideo();
          if (video.duration && isFinite(video.duration)) {
            progress = video.currentTime / video.duration;
          }
        }

        this.setBar(this.index, Math.min(progress, 1));

        if (progress >= 1 && this.isTimed()) this.next();

        this.raf = requestAnimationFrame(this.tick);
      }
    }

    customElements.define('ugc-story-card', UgcStoryCard);
  }

  } catch(e) { console.error(e); }
})();
})();
